import React, { useState, useEffect, useRef } from 'react';
import { withRouter, Link } from 'react-router-dom';
import Cookies from 'js-cookie';
import _, { isEmpty } from 'lodash';
import {
  Form,
  Input,
  Button,
  Table,
  notification,
  Modal,
  Spin,
  Space,
  Select,
  Switch,
} from 'antd';
import {
  PlusCircleTwoTone,
  EditOutlined,
  EyeOutlined,
  DeleteOutlined,
} from '@ant-design/icons';
import whatsapp from '../../assets/images/whatsapp.svg';
import sms from '../../assets/images/sms.svg';
import email from '../../assets/images/email.svg';
import './channels.less';
import API from '../../utils/Api';
import HTMLEditor from '../../utils/jodit-react-component';

const { Column, ColumnGroup } = Table;
const { Option } = Select;
const { TextArea } = Input;
const Channels = () => {
  const [EmailupdateID, setEmailKey] = useState(null);
  const [SMSupdateID, setSMSKey] = useState(null);
  const [WhatsupdateID, setWhatsKey] = useState(null);
  const [pushupdateID, setPushKey] = useState(null);
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [EmailModalVisible, setEmailModalVisible] = useState(false);
  const [EmaileditModalVisible, setEmaileditModalVisible] = useState(false);
  const [EmailModalvalue, setEmailModalvalue] = useState('');
  const [SMSModalVisible, setSMSModalVisible] = useState(false);
  const [SMSeditModalVisible, setSMSeditModalVisible] = useState(false);
  const [SMSModalvalue, setSMSModalvalue] = useState('');

  const [WhatsModalVisible, setWhatsModalVisible] = useState(false);
  const [WhatseditModalVisible, setWhatseditModalVisible] = useState(false);
  const [WhatsModalvalue, setWhatsModalvalue] = useState('');

  const [pushModalVisible, setPushModalVisible] = useState(false);
  const [pushEditModalVisible, setPushEditModalVisible] = useState(false);
  const [pushModalvalue, setPushModalvalue] = useState('');

  const [loadingBtn, setLoadingBtn] = useState(false);
  const [emailvariableCount, setemailVariableCount] = useState(0);
  const [smsvariableCount, setsmsVariableCount] = useState(0);
  const joditEditor = useRef(null);
  const myApi = new API({});
  const [form] = Form.useForm();
  myApi.createEntity({ name: 'message-template' });

  const fetchData = () => {
    setLoading(true);
    const appId = Cookies.get('appID');
    const params = { params: { template_type: 'all' } };
    const apiArray = [myApi.endpoints.messageTemplate.getAll(params, {}, appId)];
    Promise.all(apiArray)
      .then((res) => {
        const templateData = res[0].data;
        setTableData(templateData);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
        notification.error({ message: 'Failed to load the data.' });
      });
  };
  useEffect(() => {
    fetchData();
  }, []);
  const handleEmailAddVariable = () => {
    setemailVariableCount(emailvariableCount + 1);
  };
  const handleSMSAddVariable = () => {
    setsmsVariableCount(smsvariableCount + 1);
  };

  useEffect(() => {
    if (emailvariableCount) {
      joditEditor.current.component.selection.insertHTML(`<span>{{${emailvariableCount}}}</span>`);
    }
  }, [emailvariableCount]);

  useEffect(() => {
    if (smsvariableCount) {
      const templateValue = form.getFieldValue('sms_content');
      form.setFieldsValue({
        sms_content: `${templateValue}{{$${smsvariableCount}}}`,
      });
    }
  }, [smsvariableCount]);
  // Email
  const handleEmailPreview = (data) => {
    setEmailModalVisible(true);
    setEmailModalvalue(data);
  };
  const handleEmailEdit = (values) => {
    setEmailKey(values.eid);
    form.setFieldsValue(values);
    setEmaileditModalVisible(true);
  };

  const onEmailFinish = (values) => {
    setLoadingBtn(true);
    values.app_id = Cookies.get('appID');
    values.template_type = 'email';
    values.template_types = 'all';
    values.id = EmailupdateID;
    myApi.endpoints.messageTemplate
      .update(values)
      .then(() => {
        notification.success({ message: 'updated successfully.' });
        setLoadingBtn(false);
        setEmailKey(null);
        setEmaileditModalVisible(false);
        form.resetFields();
        fetchData();
      })
      .catch((err) => {
        setLoadingBtn(false);
        notification.error({
          message: _.get(
            err,
            'response.data.message',
            'Failed to update email template.',
          ),
        });
      });
  };

  // SMS
  const handleSMSEdit = (values) => {
    setSMSKey(values.sid);
    form.setFieldsValue(values);
    setSMSeditModalVisible(true);
  };
  const handleSMSPreview = (data) => {
    setSMSModalVisible(true);
    setSMSModalvalue(data);
  };
  // Whatsapp
  const handleWhatsEdit = (values) => {
    setWhatsKey(values.wid);
    form.setFieldsValue(values);
    setWhatseditModalVisible(true);
  };
  const handleWhatsPreview = (data) => {
    setWhatsModalVisible(true);
    setWhatsModalvalue(data);
  };
  const onSMSFinish = (values) => {
    setLoadingBtn(true);
    values.app_id = Cookies.get('appID');
    values.template_type = 'sms';
    values.template_types = 'all';
    values.id = SMSupdateID;
    myApi.endpoints.messageTemplate
      .update(values)
      .then(() => {
        notification.success({ message: 'updated successfully.' });
        setLoadingBtn(false);
        setSMSKey(null);
        setSMSeditModalVisible(false);
        form.resetFields();
        fetchData();
      })
      .catch((err) => {
        setLoadingBtn(false);
        notification.error({
          message: _.get(
            err,
            'response.data.message',
            'Failed to update SMS template.',
          ),
        });
      });
  };

  const onWhatsFinish = (values) => {
    setLoadingBtn(true);
    values.app_id = Cookies.get('appID');
    values.template_type = 'whatsapp';
    values.template_types = 'all';
    values.id = WhatsupdateID;
    myApi.endpoints.messageTemplate
      .update(values)
      .then(() => {
        notification.success({ message: 'updated successfully.' });
        setLoadingBtn(false);
        setWhatsKey(null);
        setWhatseditModalVisible(false);
        form.resetFields();
        fetchData();
      })
      .catch((err) => {
        setLoadingBtn(false);
        notification.error({
          message: _.get(
            err,
            'response.data.message',
            'Failed to update Whatsapp template.',
          ),
        });
      });
  };

  // Push Notification
  const handlePushPreview = (data) => {
    setPushModalVisible(true);
    setPushModalvalue(data);
  };

  const handlePushEdit = (values) => {
    if (!isEmpty(values.push_notification_template)) {
      setPushKey(values.push_notification_template.nid);
      form.setFieldsValue(values.push_notification_template);
    } else {
      setPushKey(null);
      form.setFieldsValue({ ...values.push_notification_template, template_name: values.template_name, notification_content: '' });
    }
    setPushEditModalVisible(true);
  };

  const onPushFinish = (values) => {
    setLoadingBtn(true);
    if (pushupdateID) {
      values.app_id = Cookies.get('appID');
      values.template_type = 'push_notification';
      values.template_types = 'all';
      values.id = pushupdateID;
      myApi.endpoints.messageTemplate
        .update(values)
        .then(() => {
          notification.success({ message: 'updated successfully.' });
          setLoadingBtn(false);
          setPushKey(null);
          setPushEditModalVisible(false);
          form.resetFields();
          fetchData();
        })
        .catch((err) => {
          setLoadingBtn(false);
          notification.error({
            message: _.get(
              err,
              'response.data.message',
              'Failed to update push notification template.',
            ),
          });
        });
    } else {
      values.app_id = Cookies.get('appID');
      values.template_type = 'push_notification';
      values.template_name = form.getFieldValue('template_name');
      myApi.endpoints.messageTemplate
        .create(values)
        .then(() => {
          notification.success({ message: 'updated successfully.' });
          setLoadingBtn(false);
          setPushEditModalVisible(false);
          form.resetFields();
          fetchData();
        })
        .catch((err) => {
          setLoadingBtn(false);
          notification.error({
            message: _.get(
              err,
              'response.data.message',
              'Failed to update push notification template.',
            ),
          });
        });
    }
  };

  const onTemplateStatusChange = (checked, templateType, templateId) => {
    setLoading(true);
    const payload = {
      is_enabled: checked,
      template_type: templateType,
      id: templateId,
      app_id: Cookies.get('appID'),
    };
    myApi.endpoints.messageTemplate.update(payload, {}, '/update-status').then(() => {
      fetchData();
      notification.success({ message: 'Template status updated successfully.' });
    }).catch((err) => {
      setLoading(false);
      notification.error({
        message: _.get(
          err,
          'response.data.message',
          'Failed to update template status.',
        ),
      });
    });
  };

  return (
    <Spin spinning={loading}>
      {/* <div className="info-card info-container">
        <div>
          <Link to="/channels/whatsapp">
            <div>
              <div>
                <div className="col-full">
                  <h2>WHATSAPP</h2>
                  <p>
                    Expand your customer reach today through a WhatsApp for
                    business account
                  </p>
                </div>
                <div className="col-auto">
                  <img className="avatar64" src={whatsapp} alt="WhatsApp" />
                </div>
              </div>
              <div>
                <h3>WhatsApp Management</h3>
              </div>
            </div>
          </Link>
        </div>
        <div>
          <Link to="/channels/sms">
            <div>
              <div>
                <div className="col-full">
                  <h2>SMS</h2>
                  <p>
                    Expand your customer reach today through the SMS for
                    business account
                  </p>
                </div>
                <div className="col-auto">
                  <img className="avatar64" src={sms} alt="SMS" />
                </div>
              </div>
              <div>
                <h3>SMS Management</h3>
              </div>
            </div>
          </Link>
        </div>
        <div>
          <Link to="/channels/email">
            <div>
              <div>
                <div className="col-full">
                  <h2>MAIL</h2>
                  <p>
                    Expand your customer reach today through the Email for
                    business account
                  </p>
                </div>
                <div className="col-auto">
                  <img className="avatar64" src={email} alt="Email" />
                </div>
              </div>
              <div>
                <div>
                  <h3>MAIL Management</h3>
                </div>
              </div>
            </div>
          </Link>
        </div>
      </div> */}
      <div>
        <div
          style={{
            display: 'flex', justifyContent: 'flex-end', paddingBottom: '15px', paddingTop: '20px',
          }}
        >
          <Link to="/channels/Templates">
            {' '}
            <Button type="primary" style={{ marginBottom: '5px' }}>
              <PlusCircleTwoTone />
              {' '}
              Add Template
            </Button>
          </Link>
        </div>
        <Table className="grid-table" bordered dataSource={tableData}>
          <Column
            title="Template Name"
            dataIndex="template_name"
            key="template_name"
          />
          <ColumnGroup title="WhatsApp">
            <Column
              title="Action"
              align="center"
              dataIndex="whatsapp_template"
              key="whatsapp_template"
              render={(text, record) => {
                if (text?.template_name) {
                  if (text?.whatsapp_content) {
                    return (
                      <Space size="middle">
                        <EditOutlined
                          style={{ color: 'green' }}
                          onClick={() => {
                            handleWhatsEdit(text);
                          }}
                        />
                        <EyeOutlined
                          style={{ color: 'rgb(12, 99, 99)' }}
                          onClick={() => {
                            handleWhatsPreview(text);
                          }}
                        />
                      </Space>
                    );
                  }
                  return (
                    <PlusCircleTwoTone
                      onClick={() => {
                        handleWhatsEdit(text);
                      }}
                    />
                  );
                }
              }}
            />
            <Column
              title="Status"
              align="center"
              dataIndex="whatsapp_template"
              key="whatsapp_template"
              render={(text, record) => (
                <div>
                  {text?.whatsapp_content ? <Switch checked={text.is_enabled} onChange={(checked) => onTemplateStatusChange(checked, 'whatsapp', text.template_id)} size="small" /> : ''}
                </div>
              )}
            />
          </ColumnGroup>
          <ColumnGroup title="SMS">
            <Column
              title="Action"
              align="center"
              dataIndex="sms_template"
              key="sms_template"
              render={(text, record) => {
                if (text?.template_name) {
                  if (text?.sms_content) {
                    return (
                      <Space size="middle">
                        <EditOutlined
                          style={{ color: 'green' }}
                          onClick={() => {
                            handleSMSEdit(text);
                          }}
                        />
                        <EyeOutlined
                          style={{ color: 'rgb(12, 99, 99)' }}
                          onClick={() => {
                            handleSMSPreview(text);
                          }}
                        />
                      </Space>
                    );
                  }
                  return (
                    <PlusCircleTwoTone
                      onClick={() => {
                        handleSMSEdit(text);
                      }}
                    />
                  );
                }
              }}
            />
            <Column
              title="Status"
              align="center"
              dataIndex="sms_template"
              key="sms_template"
              render={(text, record) => (
                <div>{text?.sms_content ? <Switch checked={text.is_enabled} onChange={(checked) => onTemplateStatusChange(checked, 'sms', text.template_id)} size="small" /> : ''}</div>
              )}
            />
          </ColumnGroup>
          <ColumnGroup title="Email">
            <Column
              title="Action"
              align="center"
              dataIndex="email_template"
              key="email_template"
              render={(text, record) => {
                if (text?.template_name) {
                  if (text?.email_content) {
                    return (
                      <Space size="middle">
                        <EditOutlined
                          style={{ color: 'green' }}
                          onClick={() => {
                            handleEmailEdit(text);
                          }}
                        />
                        <EyeOutlined
                          style={{ color: 'rgb(12, 99, 99)' }}
                          onClick={() => {
                            handleEmailPreview(text.email_content);
                          }}
                        />
                      </Space>
                    );
                  }
                  return (
                    <PlusCircleTwoTone
                      onClick={() => {
                        handleEmailEdit(text);
                      }}
                    />
                  );
                }
              }}
            />
            <Column
              title="Status"
              align="center"
              dataIndex="email_template"
              key="email_template"
              render={(text, record) => (
                <div>{text?.email_content ? <Switch checked={text.is_enabled} onChange={(checked) => onTemplateStatusChange(checked, 'email', text.template_id)} size="small" /> : null}</div>
              )}
            />
          </ColumnGroup>
          <ColumnGroup title="Push">
            <Column
              title="Action"
              align="center"
              key="push_notification_template"
              render={(text, record) => {
                if (text?.push_notification_template?.notification_content) {
                  return (
                    <Space size="middle">
                      <EditOutlined
                        style={{ color: 'green' }}
                        onClick={() => {
                          handlePushEdit(text);
                        }}
                      />
                      <EyeOutlined
                        style={{ color: 'rgb(12, 99, 99)' }}
                        onClick={() => {
                          handlePushPreview(text.push_notification_template);
                        }}
                      />
                    </Space>
                  );
                }
                return (
                  <PlusCircleTwoTone
                    onClick={() => {
                      handlePushEdit(text);
                    }}
                  />
                );
              }}
            />
            <Column
              title="Status"
              align="center"
              dataIndex="push_notification_template"
              key="push_notification_template"
              render={(text, record) => (
                <div>
                  {text?.notification_content
                    ? (
                      <Switch
                        checked={text.is_enabled}
                        onChange={(checked) => onTemplateStatusChange(checked, 'push_notification', text.template_id)}
                        size="small"
                      />
                    ) : null}
                </div>
              )}
            />
          </ColumnGroup>
          <Column
            title="Bulk Actions"
            align="center"
            // dataIndex="template_name"
            // key="template_name"
            render={(text, record) => {
              if (text.template_name) {
                return (
                  <Space size="middle">
                    <EditOutlined
                      style={{ color: 'green' }}
                      onClick={() => {
                        // handleEmailEdit(text);
                      }}
                    />
                    <DeleteOutlined
                      style={{ color: 'red' }}
                      onClick={() => {
                        // handleEmailPreview(text.email_content);
                      }}
                    />
                  </Space>
                );
              }
              return null;
            }}
          />
        </Table>
      </div>
      {/* EMail Start */}
      {EmailModalVisible ? (
        <div>
          <Modal
            width={500}
            title="Email Template view"
            visible
            onOk={() => {
              setEmailModalVisible(false);
            }}
            onCancel={() => {
              setEmailModalVisible(false);
            }}
          >
            <p dangerouslySetInnerHTML={{ __html: EmailModalvalue }} />
          </Modal>
        </div>
      ) : (
        ''
      )}
      {EmaileditModalVisible ? (
        <div>
          <Modal
            width="80vw"
            title="Email Template view"
            visible
            onOk={() => {
              setEmaileditModalVisible(false);
            }}
            footer={false}
            onCancel={() => {
              setEmaileditModalVisible(false);
            }}
          >
            <Form form={form} layout="vertical" onFinish={onEmailFinish}>
              <Form.Item
                label="Template Name"
                name="template_name"
                initialValue=""
                rules={[
                  {
                    required: true,
                    message: 'Please enter title name!',
                  },
                  // { min: 3, message: 'Title must be minimum 3 characters.' },
                ]}
              >
                <Input />
              </Form.Item>
              <Form.Item label="Status" name="is_enabled" valuePropName="checked">
                <Switch defaultChecked />
              </Form.Item>
              <Form.Item style={{ textAlign: 'right', marginBottom: 0 }}>
                <Button
                  icon={<PlusCircleTwoTone />}
                  onClick={handleEmailAddVariable}
                  type="link"
                >
                  Add Email Variable
                </Button>
              </Form.Item>
              <Form.Item
                label="Template Content"
                name="email_content"
                initialValue=""
                rules={[
                  {
                    required: true,
                    message: 'Please enter the content!',
                  },
                  // { min: 3, message: 'Description must be minimum 3 characters.' },
                ]}
              >
                <HTMLEditor
                  // onChange={(c) => setEmailContent(c)}
                  config={{ minHeight: 300 }}
                  ref={joditEditor}
                />
              </Form.Item>
              <Form.Item style={{ 'margin-bottom': 0 }}>
                <Button htmlType="submit" type="primary" disabled={loadingBtn}>
                  {loadingBtn ? 'Submitting...' : 'Submit'}
                </Button>
              </Form.Item>
            </Form>
          </Modal>
        </div>
      ) : (
        ''
      )}
      {/* Email end */}
      {/* SMS start */}
      {SMSModalVisible ? (
        <div>
          <Modal
            width={500}
            title="SMS Template view"
            visible
            onOk={() => {
              setSMSModalVisible(false);
            }}
            onCancel={() => {
              setSMSModalVisible(false);
            }}
          >
            <span>{SMSModalvalue.sms_content}</span>
          </Modal>
        </div>
      ) : (
        ''
      )}
      {SMSeditModalVisible ? (
        <div>
          <Modal
            width={500}
            title="SMS Template view"
            visible
            onOk={() => {
              setSMSeditModalVisible(false);
            }}
            footer={false}
            onCancel={() => {
              setSMSeditModalVisible(false);
            }}
          >
            <Form form={form} layout="vertical" onFinish={onSMSFinish}>
              <Form.Item
                label="Template Id"
                name="smstemplate_id"
                rules={[
                  {
                    required: true,
                    message: 'Please enter template id',
                  },
                  {
                    validator(rule, value) {
                      const pattern = /^[0-9\b]+$/;
                      if (value && !value.match(pattern)) {
                        return Promise.reject(
                          new Error('Please enter only number'),
                        );
                      }
                      return Promise.resolve();
                    },
                  },
                ]}
              >
                <Input />
              </Form.Item>
              <Form.Item
                label="Sender Id"
                name="sender_id"
                rules={[
                  {
                    required: true,
                    message: 'Please enter sender id!',
                  },
                ]}
              >
                <Input />
              </Form.Item>
              <Form.Item
                name="sms_type"
                label="Purpose"
                hasFeedback
                rules={[
                  { required: 'true', message: 'Please select Purpose!' },
                ]}
              >
                <Select placeholder="Please select Puropose" allowClear>
                  <Option value="OTP">OTP</Option>
                  <Option value="MKT">Marketing</Option>
                  <Option value="TXN">Transactional</Option>
                </Select>
              </Form.Item>
              <Form.Item style={{ textAlign: 'right', marginBottom: 0 }}>
                <Button
                  icon={<PlusCircleTwoTone />}
                  onClick={handleSMSAddVariable}
                  type="link"
                >
                  Add sms Variable
                </Button>
              </Form.Item>
              <Form.Item
                label="Template Content"
                name="sms_content"
                initialValue=""
                rules={[
                  {
                    required: true,
                    message: 'Please enter the content!',
                  },
                  // { min: 3, message: 'Description must be minimum 3 characters.' },
                ]}
              >
                <TextArea rows={8} maxLength={1000} />
              </Form.Item>
              <Form.Item style={{ 'margin-bottom': 0 }}>
                <Button htmlType="submit" type="primary" disabled={loadingBtn}>
                  {loadingBtn ? 'Submitting...' : 'Submit'}
                </Button>
              </Form.Item>
            </Form>
          </Modal>
        </div>
      ) : (
        ''
      )}
      {/* SMS end */}
      {/* Whatsapp start */}
      {WhatsModalVisible ? (
        <div>
          <Modal
            width={500}
            title="WhatsApp Template view"
            visible
            onOk={() => {
              setWhatsModalVisible(false);
            }}
            onCancel={() => {
              setWhatsModalVisible(false);
            }}
          >
            <span>{WhatsModalvalue.whatsapp_content}</span>
          </Modal>
        </div>
      ) : (
        ''
      )}
      {WhatseditModalVisible ? (
        <div>
          <Modal
            width={500}
            title="WhatsApp Template view"
            visible
            onOk={() => {
              setWhatseditModalVisible(false);
            }}
            footer={false}
            onCancel={() => {
              setWhatseditModalVisible(false);
            }}
          >
            <Form form={form} layout="vertical" onFinish={onWhatsFinish}>
              <Form.Item
                label="Template Content"
                name="whatsapp_content"
                rules={[
                  {
                    required: true,
                    message: 'Please enter the content!',
                  },
                  {
                    min: 3,
                    message: 'Description must be minimum 3 characters.',
                  },
                  { message: 'Description must be minimum 3 characters.' },
                ]}
              >
                <Input.TextArea rows={8} maxLength={1000} />
              </Form.Item>
              {!isEmpty(form.getFieldValue(['whatsapp_media_type']))
                && (
                  <Form.Item
                    label="Media Type"
                    name="whatsapp_media_type"
                    rules={[
                      {
                        required: true,
                        message: 'Please select the whatsapp media type!',
                      },
                    ]}
                  >
                    <Select
                        placeholder="Please select media type"
                        allowClear
                      >
                        <Option value="Document">Document</Option>
                        <Option value="Image">Image</Option>
                        <Option value="Video">Video</Option>
                      </Select>
                  </Form.Item>
                )}
              {!isEmpty(form.getFieldValue(['whatsapp_header']))
                && (
                  <Form.Item
                    label="WhatsApp header"
                    name="whatsapp_header"
                    rules={[
                      {
                        required: true,
                        message: 'Please enter the whatsapp header!',
                      },
                      {
                        min: 3,
                        message: 'Description must be minimum 3 characters.',
                      },
                      { message: 'Description must be minimum 3 characters.' },
                    ]}
                  >
                    <Input />
                  </Form.Item>
                )}
              {!isEmpty(form.getFieldValue(['whatsapp_footer']))
                && (
                <Form.Item
                  label="WhatsApp footer"
                  name="whatsapp_footer"
                  rules={[
                    {
                      required: true,
                      message: 'Please enter the whatsapp footer!',
                    },
                    {
                      min: 3,
                      message: 'Description must be minimum 3 characters.',
                    },
                    { message: 'Description must be minimum 3 characters.' },
                  ]}
                >
                  <Input />
                </Form.Item>
                )}
              <Form.Item style={{ 'margin-bottom': 0 }}>
                <Button htmlType="submit" type="primary" disabled={loadingBtn}>
                  {loadingBtn ? 'Submitting...' : 'Submit'}
                </Button>
              </Form.Item>
            </Form>
          </Modal>
        </div>
      ) : (
        ''
      )}
      {/* Whatsapp end */}
      {/* Push start */}
      {pushModalVisible ? (
        <div>
          <Modal
            width={500}
            title="Push Notification Template view"
            visible
            onOk={() => {
              setPushModalVisible(false);
            }}
            onCancel={() => {
              setPushModalVisible(false);
            }}
          >
            <span>{pushModalvalue.notification_content}</span>
          </Modal>
        </div>
      ) : (
        ''
      )}
      {pushEditModalVisible ? (
        <div>
          <Modal
            width={500}
            title="Push Notification Template view"
            visible
            onOk={() => {
              setPushEditModalVisible(false);
            }}
            footer={false}
            onCancel={() => {
              setPushEditModalVisible(false);
            }}
          >
            <Form form={form} layout="vertical" onFinish={onPushFinish}>
              <Form.Item
                label="Template Content"
                name="notification_content"
                rules={[
                  {
                    required: true,
                    message: 'Please enter the content!',
                  },
                  {
                    min: 3,
                    message: 'Description must be minimum 3 characters.',
                  },
                  { message: 'Description must be minimum 3 characters.' },
                ]}
              >
                <Input.TextArea rows={8} maxLength={1000} />
              </Form.Item>
              <Form.Item style={{ 'margin-bottom': 0 }}>
                <Button htmlType="submit" type="primary" disabled={loadingBtn}>
                  {loadingBtn ? 'Submitting...' : 'Submit'}
                </Button>
              </Form.Item>
            </Form>
          </Modal>
        </div>
      ) : (
        ''
      )}
      {/* Push end */}
    </Spin>
  );
};
export default withRouter(Channels);
